import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../utils/utils';

export default data => {
  const dataSearch = parseToMutationRequest(data, []);
  return gql`
  query {
    getBillableServiceProvisioningAttributes(input: ${dataSearch}) {
      provisioningAttributes {
        name
        value
      }
    }
  }
`;
};
